<template>
  <v-chip
    :small="size === 'small'"
    :x-small="size === 'x-small'"
    :class="['premium-member-badge', `premium-member-badge--${variant}`]"
    label
  >
    <v-icon left :small="size !== 'large'" :size="size === 'large' ? 18 : undefined">
      mdi-crown
    </v-icon>
    {{ label }}
  </v-chip>
</template>

<script lang="ts">
import Vue from "vue";

export default Vue.extend({
  name: "PremiumMemberBadge",
  props: {
    label: {
      type: String,
      default: "Associado Premium",
    },
    size: {
      type: String,
      default: "small",
    },
    variant: {
      type: String,
      default: "gold",
    },
  },
});
</script>

<style scoped>
.premium-member-badge {
  font-weight: 700;
  letter-spacing: 0.02em;
}

.premium-member-badge--gold {
  background: linear-gradient(135deg, #fff8e1 0%, #ffe082 100%) !important;
  color: #5d4037 !important;
  border: 1px solid #ffca28;
}

.premium-member-badge--dark {
  background: linear-gradient(135deg, #1a1a2e 0%, #4527a0 100%) !important;
  color: #ffd54f !important;
  border: 1px solid rgba(255, 213, 79, 0.35);
}
</style>
